export const dateMathRegExp = /^(?:(\d+)d\s*)?(?:(\d+)h\s*)?(?:(\d+)m)?$/;
export const integerRegExp = /^\d+$/;
export const floatRegExp = /^\d+\.\d+$/;
export const numberRegExp = /^\d+(?:\.\d+)?$/;

export const Operators = {
    eq: 'eq',
    ne: 'ne',
    in: 'in',
    nin: 'nin',
    all: 'all',
    gt: 'gt',
    gte: 'gte',
    lt: 'lt',
    lte: 'lte',
    exists: 'exists'
};

export const Types = {
    boolean: 'boolean',
    null: 'null',
    string: 'string',
    keyword: 'keyword',
    number: 'number',
    date: 'date'
};

export const MutuallyExclusiveOperatorBuckets = {
    [Operators.eq]: [Operators.ne, Operators.all, Operators.gt, Operators.gte, Operators.lt, Operators.lte, Operators.exists],
    [Operators.ne]: [Operators.eq, Operators.nin, Operators.gt, Operators.gte, Operators.lt, Operators.lte],
    [Operators.in]: [Operators.gt, Operators.gte, Operators.lt, Operators.lte, Operators.exists],
    [Operators.nin]: [Operators.ne, Operators.gt, Operators.gte, Operators.lt, Operators.lte],
    [Operators.all]: [Operators.eq, Operators.gt, Operators.gte, Operators.lt, Operators.lte, Operators.exists],
    [Operators.gt]: [Operators.eq, Operators.ne, Operators.in, Operators.nin, Operators.all, Operators.gte, Operators.exists],
    [Operators.gte]: [Operators.eq, Operators.ne, Operators.in, Operators.nin, Operators.all, Operators.gt, Operators.exists],
    [Operators.lt]: [Operators.eq, Operators.ne, Operators.in, Operators.nin, Operators.all, Operators.lte, Operators.exists],
    [Operators.lte]: [Operators.eq, Operators.ne, Operators.in, Operators.nin, Operators.all, Operators.lt, Operators.exists],
    [Operators.exists]: [Operators.eq, Operators.in, Operators.all, Operators.gt, Operators.gte, Operators.lt, Operators.lte]
};

export const CompatibleOperatorBuckets = {
    [Operators.eq]: [Operators.in, Operators.nin],
    [Operators.ne]: [Operators.in, Operators.all, Operators.exists],
    [Operators.in]: [Operators.eq, Operators.ne, Operators.nin, Operators.all],
    [Operators.nin]: [Operators.eq, Operators.in, Operators.all, Operators.exists],
    [Operators.all]: [Operators.ne, Operators.in, Operators.nin],
    [Operators.gt]: [Operators.lt, Operators.lte],
    [Operators.gte]: [Operators.lt, Operators.lte],
    [Operators.lt]: [Operators.gt, Operators.gte],
    [Operators.lte]: [Operators.gt, Operators.gte],
    [Operators.exists]: [Operators.ne, Operators.nin]
};

export const FieldOperatorsByType = {
    [Types.boolean]: [Operators.eq, Operators.ne, Operators.exists],
    [Types.null]: [Operators.eq, Operators.ne, Operators.exists],
    [Types.string]: [Operators.eq, Operators.ne, Operators.exists, Operators.in, Operators.nin, Operators.all],
    [Types.keyword]: [Operators.eq, Operators.ne, Operators.exists, Operators.in, Operators.nin, Operators.all],
    [Types.number]: [Operators.eq, Operators.ne, Operators.exists, Operators.in, Operators.nin, Operators.all, Operators.gt, Operators.gte, Operators.lt, Operators.lte],
    [Types.date]: [Operators.gt, Operators.gte, Operators.lt, Operators.lte, Operators.exists]
};



// WEBPACK FOOTER //
// ./src/services/queueQueryEnums.js